import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { DepositPaynearmeV2Component } from './deposit-paynearme-v2.component';


@NgModule({
  declarations: [
    DepositPaynearmeV2Component
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class DepositPaynearmeV2Module {}